import "core-js/modules/es.array.join";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gradeMulUpdate } from '../../../../api/apis';
export default {
  props: {
    gradeList: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        numbers: '',
        grade: 0,
        remark: '手动定级'
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    show: function show(numbers, finish) {
      this.dialogVisible = true;
      this.form.numbers = numbers.join(',');
      this.finish = finish;
      console.log('this.gradeList', this.gradeList);
    },
    clickSubmit: function clickSubmit() {
      var _this = this;

      this.$g.fun.startLoading();
      gradeMulUpdate({
        number: this.form.numbers.split(','),
        grade: this.form.grade,
        remark: this.form.remark
      }).then(function _callee(res) {
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$g.fun.endLoading();

                _this.$message({
                  message: '批量定级成功',
                  type: 'success'
                });

                _this.dialogVisible = false;

                _this.finish();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    }
  }
};